import { createFileRoute } from "@tanstack/react-router";
import { MessagesInbox } from "@/routes/_authenticated/messages/index";

export const Route = createFileRoute("/_authenticated/partner/messages/")({
  head: () => ({
    meta: [
      { title: "Partner messages — Shields" },
      { name: "description", content: "Private conversations for your assigned Partner jobs." },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: PartnerMessages,
});

function PartnerMessages() {
  return <MessagesInbox workspace="partner" />;
}
